import { type SearchApiFetchProductsResponse } from 'legacy/sections/catalog/components/search/utils/catalogSearch.types'
import instacart from 'legacy/common/instacart'
import { compactNullObject } from 'utils/objects/compact'
import { type PartnerAndRetailerId } from 'utils/routing/params.types'

export interface SearchApiQueryParams {
  searchTerm?: string
  searchType?: string
  pageNumber?: number
  departmentId?: number
  aisleId?: number
  available?: boolean
  hasImage?: boolean
}

export interface SearchApiFetchParams extends SearchApiQueryParams, PartnerAndRetailerId {}

export interface SearchProductsApiQueryParams {
  term?: string
  searchType?: string
  page?: number
  department_ids?: number
  aisle_ids?: number
  available?: boolean
  has_image?: boolean
}

export const convertSearchParamsToApiQueryParams = (
  searchParams: SearchApiQueryParams
): SearchProductsApiQueryParams =>
  compactNullObject({
    term: searchParams.searchTerm,
    searchType: searchParams.searchType,
    page: searchParams.pageNumber,

    department_ids: searchParams.departmentId,

    aisle_ids: searchParams.aisleId,
    available: searchParams.available,

    has_image: searchParams.hasImage,
  })

export const searchProducts = (searchParams: SearchApiFetchParams) => {
  const { partnerId, retailerId } = searchParams

  const query = convertSearchParamsToApiQueryParams(searchParams)

  return instacart.go.get<SearchApiFetchProductsResponse, SearchProductsApiQueryParams>(
    `/v1/partners/${partnerId}/warehouses/${retailerId}/products/search`,
    { query }
  )
}
